









import Vue, { PropType } from 'vue';
import { BasePeerGroup, MemberRole } from '@/models';
import { GroupRoleFilter, groupRoleName } from '@/groupRole';
import { groupRoleColors } from '@/components/utils/unrulrColors';

import RoleFilterPills, {
  RoleFilterOption
} from '@/components/RoleFilterPills.vue';

const ROLES = [MemberRole.STUDENT, MemberRole.TEACHER, MemberRole.OBSERVER];

export default Vue.extend({
  components: {
    RoleFilterPills
  },

  props: {
    value: {
      type: String as PropType<GroupRoleFilter>,
      default: 'ALL' as GroupRoleFilter
    },
    peerGroup: {
      type: Object as PropType<BasePeerGroup>,
      required: true
    },
    disabled: Boolean
  },

  computed: {
    // Group role pills on each row are all the same orange, so these match.
    options(): RoleFilterOption[] {
      return ROLES.map(role => ({
        value: role,
        label: groupRoleName(role, this.peerGroup),
        activeClasses: [...groupRoleColors.all, 'grey--text', 'text--darken-4']
      }));
    }
  },

  methods: {
    onChange(value: GroupRoleFilter) {
      this.$emit('change', value);
    }
  }
});
